// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import App from './App';

import router from './router';
import ElementUI from 'element-ui';
import '../node_modules/element-ui/lib/theme-chalk/index.css';	//�ֶ����
import Public_components from '@/components/index';
import axios from 'axios';
import { copyFile } from 'fs';
import store from "./store";
import './styles/common.scss'
import './styles/fonts.css'
import * as filters from './filters' // global filters
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css';
import './icons'
import baseMixin from '@/components/Mixin/base';
import './directive';
import './utils/collectUtil'
import "./utils/dialogDrag"
import preventClick from './utils/clickStatefrom'  // 防止重复点击按钮

import vueSwiper from 'vue-awesome-swiper'  //引入vue-awesome-swiper
import 'swiper/dist/css/swiper.css'  //引入样式
import 'animate.css'

if(window.CefSharp){
  CefSharp.BindObjectAsync('BMSService');
  require('./utils/cefUtil')

}


Vue.use(vueSwiper)  //使用插件

import IdleVue from "idle-vue";

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 10*60*1000,
  startAtIdle: false
});
// 修改 el-dialog 默认点击遮罩为不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false;
// MessageBox弹窗默认点击遮罩为不关闭 prompt,confirm
window.elPrompt=ElementUI.MessageBox.prompt;
ElementUI.MessageBox.prompt= function (){
  let options={};
  // debugger
  if(arguments.length==2){
    options=arguments[1];
  }else if(arguments.length==3){
    options=arguments[2];
  }
  if(! options.closeOnClickModal){
    options.closeOnClickModal=false;
  }
  return window.elPrompt(...arguments)
}
window.elConfirm=ElementUI.MessageBox.confirm;

ElementUI.MessageBox.confirm= function (){
  let options={};
  // debugger
  if(arguments.length==2){
    options=arguments[1];
  }else if(arguments.length==3){
    options=arguments[2];
  }
  if(! options.closeOnClickModal){
    options.closeOnClickModal=false;
  }
  return window.elConfirm(...arguments)
}

//  axios.defaults.baseURL = 'http://192.168.0.162:18080/battery_admin'  //李振湘
//  axios.defaults.baseURL = 'http://192.168.0.108:18080/battery_admin'  //吴至聪
//  axios.defaults.baseURL = 'http://192.168.0.163:18080/battery_admin' //zc
// axios.defaults.baseURL = 'http://192.168.0.244:18080/battery_admin'; // zxs                                                                                                                                                                                                                                                                                     

//  axios.defaults.baseURL = 'http://192.168.0.244:18080/battery_admin'; // zxs
// axios.defaults.baseURL = 'http://47.112.163.91:8081/battery_admin'  //生产（伪生产）
// axios.defaults.baseURL = 'http://192.168.0.206:18080/battery_admin' //谷永辉
// axios.defaults.baseURL = 'http://dev.fnjkj.cn:18080/battery_admin' //测试
// axios.defaults.baseURL ='http://sxr6z2.natappfree.cc/battery_admin'  //临时
// http://dev.fnjkj.cn:8080/bcadmin/#/

// // if(true){
 //axios.defaults.baseURL = 'http://47.107.234.15:18080/battery_admin'
// }else{
//   axios.defaults.baseURL = 'http://2o57815m27.wicp.vip:36401/battery_admin'
// }


 axios.defaults.baseURL = 'https://service.fnjkj.cn/battery_admin/' //生产环境

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(ElementUI);	//�ֶ����
Vue.use(Public_components);
Vue.use(Viewer);
Vue.mixin(baseMixin);
Vue.use(preventClick)


Vue.prototype.$message = function(msg){
  // ElementUI.Message(msg)
  ElementUI.Message({...msg,showClose:true,offset:200})
}
const messageArr = ['success', 'warning', 'info', 'error']
messageArr.forEach(function (type) {
  let configDet = {
      showClose: true,
      offset:200
  }
  Vue.prototype.$message[type] = function (message) {
      return ElementUI.Message[type]({
          message,
          ...configDet
      });
  }
})


Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});
Viewer.setDefaults({
  Options: {
    "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true,
    "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true,
    "transition": true, "fullscreen": false, "keyboard": true, "url": "data-source"
  }
});
axios.interceptors.request.use(function (config) {
  let token = sessionStorage.getItem("token")
  config.headers['access-token'] = token
  // console.log(config)
  return config;
}, function (error) {
  return Promise.reject(error);
});
Vue.prototype.$axios = axios;
Vue.prototype.$EventBus = new Vue();
let theme=localStorage.getItem("theme")
if(!theme){
  theme="theme2";
}
window.document.documentElement.setAttribute('data-theme', theme);
store.dispatch('settings/changeSetting', {
  key: 'theme',
  value: theme
})
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})





// WEBPACK FOOTER //
// ./src/main.js